if (typeof Promise === 'undefined') {
    require('promise/lib/rejection-tracking').enable();
    window.Promise = require('promise/lib/es6-extensions.js');
}

if (typeof window.Promise.allSettled !== 'function') {
    window.Promise.allSettled = function(values) {
        return window.Promise.all(
            values.map(function(promise) {
                return Promise.resolve(promise).then(
                    function(value) {
                        return { status: 'fulfilled', value };
                    },
                    function(reason) {
                        return { status: 'rejected', reason };
                    },
                );
            }),
        );
    };
}

Object.assign = require('object-assign');

require('core-js/es/symbol');
require('core-js/es/array/from');
require('core-js/es/array/is-array');
require('core-js/es/array/find-index');
require('core-js/es/array/find');
require('core-js/es/array/includes');
require('core-js/es/array/some');
require('core-js/es/array/every');
require('core-js/es/array/is-array');
require('core-js/es/string/includes');
require('core-js/es/string/trim');
require('core-js/es/object/entries');
require('core-js/es/string/pad-start');
require('core-js/es/object/values');
require('core-js/es/map');
require('core-js/es/set');
require('raf').polyfill(window);

if (!document.body.scrollTo) {
    Element.prototype.scrollTo = function(x, y) {
        this.scrollLeft = x;
        this.scrollTop = y;
    };
}
